import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { MessageDescriptor } from 'react-intl';

export enum SMLSettingsTabId {
  subscription = 'subscription',
  account = 'account',
  artist = 'artist',
  team = 'team',
  /**
   * The social accounts (navigation v2, design f 6b): the old Channels page. Its address stays
   * `/app/promote/promoteChannels` (emails, pushes and the OAuth return use it).
   */
  connections = 'connections',
  notifications = 'notifications',
  /** Outreach mailboxes (design outreach i1). IMAP + SMTP only (owner decision 2026-10-12). */
  outreach = 'outreach',
  setup = 'setup',
  smartlinks = 'smartlinks',
  aiAssistants = 'ai-assistants',
  api = 'api',
  legal = 'legal',
  support = 'support',
}

/**
 * The rail draws a thin line between two blocks (design settings-redesign a1): you, the
 * workspace, the product, help.
 */
export type SMLSettingsTabBlock = 'you' | 'workspace' | 'product' | 'help';

export interface SMLSettingsTabDef {
  id: SMLSettingsTabId;
  label: MessageDescriptor;
  /** The title of the page head when it is not the label. */
  title?: MessageDescriptor;
  /** The line under the title in the page head. The breadcrumbs say "Settings / <label>". */
  subtitle: MessageDescriptor;
  icon: IconDefinition;
  block: SMLSettingsTabBlock;
}
